import React from 'react';
import { Checkbox } from '@fourthwall/components';
import * as S from './AnalyticsFiltersSelect.styled';
export const AnalyticsFiltersSelect = ({ filters, onChange }) => {
    const handleCheckboxChange = (sectionTitle, itemValue, checked) => onChange(sectionTitle, itemValue, checked);
    const visibleFilters = filters.filter((section) => {
        if (section.enabled === false)
            return false;
        if (!section.items || section.items.length === 0)
            return false;
        const hasEnabledItems = section.items.some((item) => item.enabled !== false);
        if (!hasEnabledItems)
            return false;
        return true;
    });
    return (React.createElement(S.Container, null, visibleFilters.map(({ title, items }, index) => {
        const visibleItems = items.filter((item) => item.enabled !== false);
        if (visibleItems.length === 0)
            return null;
        return (React.createElement(React.Fragment, { key: title },
            React.createElement(S.Section, null,
                React.createElement(S.SectionTitle, null, title),
                visibleItems.map((item) => {
                    const itemKey = Array.isArray(item.value) ? item.value[0] : item.value;
                    const itemValue = Array.isArray(item.value) ? item.value[0] : item.value;
                    return (React.createElement(S.SelectItem, { key: itemKey },
                        React.createElement(Checkbox, { native: true, label: item.label, value: itemValue, checked: item.checked, onValueChange: (checked) => handleCheckboxChange(title, itemValue, checked) })));
                })),
            index + 1 < visibleFilters.length && React.createElement(S.Divider, null)));
    })));
};
